import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Archive, ArchiveRestore, MapPin } from 'lucide-react';

export function ArchivedSchoolsDialog({ open, onOpenChange, schools, onRestore }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Archive className="h-5 w-5 text-slate-600" />
            Archived Schools
          </DialogTitle>
          <DialogDescription>
            Schools that have been archived. Restore a school to return it to your main dashboard.
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-2">
          {schools.length === 0 ? (
            <div className="text-center py-12">
              <Archive className="h-12 w-12 text-slate-300 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-slate-700 mb-2">No archived schools</h3>
              <p className="text-sm text-slate-500">Schools can be archived from their Settings page</p>
            </div>
          ) : (
            schools.map((school) => (
              <Card key={school.school_id} className="border-slate-200">
                <CardContent className="p-4">
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex-1 min-w-0">
                      <h4 className="font-semibold text-slate-900">{school.name}</h4>
                      <p className="text-sm text-slate-500 flex items-center gap-1 mt-1">
                        <MapPin className="h-3 w-3" />
                        {school.address}
                      </p>
                      <p className="text-xs text-slate-400 mt-1">
                        Code: {school.school_code} | {school.toc_list?.length || 0} Subs
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="sm"
                      className="text-emerald-600 border-emerald-200 hover:bg-emerald-50"
                      onClick={() => onRestore(school.school_id)}
                      data-testid={`restore-school-${school.school_id}`}
                    >
                      <ArchiveRestore className="h-4 w-4 mr-1" />
                      Restore
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
        
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="w-full sm:w-auto"
            data-testid="back-to-schools-btn"
          >
            Back to Your Schools
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
